const styleOverrides = {
  contained: {
    marginLeft: 14,
    marginRight: 14
  }
};
export default {
  styleOverrides
};
//# sourceMappingURL=MuiFormHelperText.js.map